import { slateGQLFields } from './slate.fields.js'

export type navigationSlatesFields = 'all'

export const navigationSlatesGQLFields = (fields: navigationSlatesFields) => `
  headerDisabled
  sidebar1Disabled
  header {
    ${slateGQLFields(fields)}
  }
  sidebar1 {
    ${slateGQLFields(fields)}
  }
  sidebar2 {
    ${slateGQLFields(fields)}
  }
  footer {
    ${slateGQLFields(fields)}
  }
`
